import {Map, List, fromJS} from 'immutable';
import axios from "axios";
import { toast } from "react-toastify";
import {fetchAreaControlledItems} from "../../areacontrol/admin/reducer";

export const types = {
    INIT: 'MODULEADMIN/INIT',
    FETCH_MODULES: 'MODULEADMIN/FETCH_MODULES',
    FETCH_MODULES_SUCCESS: 'MODULEADMIN/FETCH_MODULES_SUCCESS',
    FETCH_MODULE_ITEMS: 'MODULEADMIN/FETCH_MODULE_ITEMS',
    FETCH_MODULE_ITEMS_SUCCESS: 'MODULEADMIN/FETCH_MODULE_ITEMS_SUCCESS',
    FETCH_ARTICLES: 'MODULEADMIN/FETCH_ARTICLES',
    FETCH_ARTICLES_SUCCESS: 'MODULEADMIN/FETCH_ARTICLES_SUCCESS',
    SELECT_MODULE: 'MODULEADMIN/SELECT_MODULE',
    UPDATE_ARTICLE_QUERY: 'MODULEADMIN/UPDATE_ARTICLE_QUERY',
    UPDATE_MODULE_ITEM_QUERY: 'MODULEADMIN/UPDATE_MODULE_ITEM_QUERY'
};

export const initialState = fromJS({
    selectedModule: null,
    modules: [],
    moduleItems: [],
    articles: [],
    articlesPagination: {
        totalElements: 0
    },
    articleQuery: '',
    moduleItemQuery: ''
});

export default (state = initialState, action) => {
    switch (action.type) {
        case types.INIT:
            return state;
        case types.FETCH_MODULES_SUCCESS:
            return state.set('modules', fromJS(action.modules));
        case types.FETCH_MODULE_ITEMS_SUCCESS:
            return state.set('moduleItems', fromJS(action.moduleItems));
        case types.FETCH_ARTICLES_SUCCESS:
            return state.set('articles', fromJS(action.articles))
                .setIn(['articlesPagination', 'totalElements'], fromJS(action.totalElements));
        case types.SELECT_MODULE:
            return state.set('selectedModule', action.moduleName)
                .set('moduleItems', fromJS([]))
                .set('moduleItemQuery', '');
        case types.UPDATE_ARTICLE_QUERY:
            return state.set('articleQuery', fromJS(action.query));
        case types.UPDATE_MODULE_ITEM_QUERY:
            return state.set('moduleItemQuery', fromJS(action.query));
        default:
            return state
    }
};

export const initialise = () => {
    return (dispatch) => {
        dispatch(fetchModules());
    }
};

export const fetchModules = () => {
    return function (dispatch) {
        const path = __API__ + '/api/ui/module';

        return axios.get(path)
            .then(response => {
                return response.data;
            })
            .then(modules => {
                dispatch(fetchModulesSuccess(modules));
            })
            .catch(error => {
                console.log(error)
                // dispatch(errorHandler(error.response))
            });
    }
};

export const fetchModulesSuccess = (modules) => {
    return {
        type: types.FETCH_MODULES_SUCCESS,
        modules: modules
    };
};

export const fetchModuleItems = (moduleName) => {
    return function (dispatch) {
        const path = __API__ + `/api/ui/module/${moduleName}/item`;

        return axios.get(path)
            .then(response => {
                return response.data;
            })
            .then(moduleItems => {
                dispatch(fetchModuleItemsSuccess(moduleItems));
            })
            .catch(error => {
                console.log(error);
                dispatch(fetchModuleItemsSuccess([]));
            });
    }
};

export const fetchModuleItemsSuccess = (moduleItems) => {
    return {
        type: types.FETCH_MODULE_ITEMS_SUCCESS,
        moduleItems: moduleItems
    };
};

export const fetchArticles = () => {
    return function (dispatch, getState) {
        const {articleQuery} = getState().moduleAdmin.toJS();

        const path = __API__ +
            `/api/ui/article?search=${articleQuery}`;

        return axios.get(path)
            .then(response => {
                return response.data;
            })
            .then(data => {
                dispatch(fetchArticlesSuccess(data.content, data.totalElements));
            })
            .catch(error => {
                console.log(error)
            });
    }
};

export const fetchArticlesSuccess = (articles, totalElements) => {
    return {
        type: types.FETCH_ARTICLES_SUCCESS,
        articles: articles,
        totalElements: totalElements
    };
};


export const selectModule = (moduleName) => {
    return (dispatch) => {
        dispatch({
            type: types.SELECT_MODULE,
            moduleName: moduleName
        });
        dispatch(fetchModuleItems(moduleName))
            .then(() => dispatch(fetchArticles()));
    }
};

export const updateArticleQuery = (query) => {
    return function (dispatch) {
        dispatch({
            type: types.UPDATE_ARTICLE_QUERY,
            query: query
        });
        dispatch(fetchArticles());
    }
};

export const updateModuleItemQuery = (query) => {
    return {
        type: types.UPDATE_MODULE_ITEM_QUERY,
        query: query
    };
};

export const addArticlesToModule = (gtins) => {
    return function (dispatch, getState) {

        const {selectedModule} = getState().moduleAdmin.toJS();

        if(!selectedModule || selectedModule === '') {
            return Promise.resolve();
        }

        const path = __API__ + `/api/ui/module/${selectedModule}/item`;
        const command = {
            moduleName: selectedModule,
            gtins: gtins
        };

        return axios.put(path, command)
            .then(response => {
                dispatch(fetchModuleItems(selectedModule));
                dispatch(fetchArticles());
            })
            .then(() => {
                toast.success('Artikel zu Modul hinzugefügt');
            })
            .catch(error => {
                toast.error('Artikel konnten nicht zu Modul hinzugefügt werden!');
            });
    }
};

export const removeArticlesFromModule = (gtins) => {
    return function (dispatch, getState) {

        const {selectedModule} = getState().moduleAdmin.toJS();

        if(!selectedModule || selectedModule === '') {
            return Promise.resolve();
        }

        const path = __API__ + `/api/ui/module/${selectedModule}/item`;
        const command = {
            moduleName: selectedModule,
            gtins: gtins
        };

        return axios.delete(path, { data: command })
            .then(response => {
                dispatch(fetchModuleItems(selectedModule));
                dispatch(fetchArticles());
            })
            .then(() => {
                toast.success('Artikel aus Modul entfernt');
            })
            .catch(error => {
                toast.error('Artikel konnten nicht aus Modul entfernt werden!');
            });
    }
};

//selectors
export const getModuleItems = (state) => {
    if (!state.has('moduleItems')) {
        return List();
    }

    if(!state.get('moduleItemQuery')) {
        return state.get('moduleItems');
    }

    const queryTokens = state.get('moduleItemQuery').split(' ');

    const searchProperties = [
        'article.erpIdno', 'article.gtin', 'article.name', 'article.vendorArticleNumber'
    ];

    const moduleItems = state.get('moduleItems');

    return moduleItems.filter((item) => {
        return queryTokens.every((token) => {
            return searchProperties.some((propertyPath) => {
                let path = propertyPath.split('.');
                return item.getIn(path).toLowerCase().indexOf(token.toLowerCase()) > -1;
            });
        });
    })
};

export const getUnassignedArticles = (state) => {
    if (!state.has('articles')) {
        return List();
    }

    const articles = state.get('articles');
    const assignedArticles = state.get('moduleItems').map(item => item.get('article'));

    const unassignedArticles = articles.filter((article => {
        const index = assignedArticles.findIndex((assArticle) => {
            return assArticle.get('gtin') === article.get('gtin')
        });

        return (index === -1);
    }));

    return unassignedArticles;
};


// WEBPACK FOOTER //
// ./src/admin/module/admin/reducer.js